export default __webpack_public_path__ + "static/media/MICROSITIO - COLACION 1.d9ffb419.jpg";